const toggleNav = () => {
  $('.navbar .dropdown').on('show.bs.dropdown', function() {
    $(this).find('.dropdown-menu').stop(true, true).slideDown();
  });

  $('.navbar .dropdown').on('hide.bs.dropdown', function() {
    $(this).find('.dropdown-menu').stop(true, true).slideUp();
  });
};

export default toggleNav;
